import React, { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
  {
    id: 1,
    question: 'How long does an AWS migration typically take?',
    answer: 'The timeline depends on the size and complexity of your infrastructure. Smaller environments can often be migrated within a few weeks, while larger enterprise workloads may require additional planning and execution time.'
  },
  {
    id: 2,
    question: 'Will there be downtime during the migration?',
    answer: 'Our migration process is designed to minimize disruption. Through careful planning, testing, and staged deployment, downtime can often be reduced to a minimum.'
  },
  {
    id: 3,
    question: 'Can existing applications be migrated without major changes?',
    answer: 'In many cases, applications can be migrated with minimal modifications. We assess compatibility and recommend any necessary optimizations before migration begins.'
  },
  {
    id: 4,
    question: 'What are the benefits of migrating AWS workloads?',
    answer: 'Migration can help improve infrastructure efficiency, optimize operational costs, enhance performance, and provide greater flexibility for future growth.'
  },
  {
    id: 5,
    question: 'How do you ensure data security during migration?',
    answer: 'We follow industry best practices for data protection, secure transfers, access controls, and infrastructure security throughout the migration process.'
  },
  {
    id: 6,
    question: 'What happens if issues are discovered after migration?',
    answer: 'Our team performs thorough testing and validation before go-live. Post-migration support is also available to address any issues and ensure a smooth transition.'
  },
  {
    id: 7,
    question: 'Can databases be migrated without data loss?',
    answer: 'Yes. We use proven migration methods and validation processes to ensure database integrity and minimize the risk of data loss.'
  },
  {
    id: 8,
    question: 'Do you provide support after the migration is completed?',
    answer: 'Yes. We offer ongoing support, monitoring, optimization, and maintenance services to help keep your environment running efficiently.'
  },
  {
    id: 9,
    question: 'Can storage and file systems be migrated?',
    answer: 'Yes. We can migrate files, object storage, backups, and other data repositories while maintaining data integrity and accessibility.'
  },
  {
    id: 10,
    question: 'How do you handle infrastructure planning?',
    answer: 'We analyze your existing environment, identify requirements, and design a migration strategy that aligns with your business and technical goals.'
  },
  {
    id: 11,
    question: 'Can user access and permissions be preserved?',
    answer: 'Yes. Access controls, user roles, and security policies can be reviewed and migrated as part of the overall transition process.'
  },
  {
    id: 12,
    question: 'Is the migration process scalable for future growth?',
    answer: 'Absolutely. We design infrastructure solutions with scalability and long-term performance in mind to support future business requirements.'
  },
  {
    id: 13,
    question: 'How do I get started with an AWS migration project?',
    answer: 'Simply contact our team for an initial consultation. We will review your current environment, discuss your goals, and recommend the most suitable migration approach.'
  }
];  
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-gradient-to-b from-white to-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            AWS Migration Questions
          </h2>
          <div className="accent-line w-16 h-1 bg-green-500 mx-auto mb-4"></div>
          <p className="text-base md:text-lg text-gray-600">
            Helpful answers to common migration concerns and requirements
          </p>
        </div>
        
        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={faq.id}
              className="rounded-lg border overflow-hidden bg-white border-gray-200 hover:border-orange-500 transition-colors duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  strokeWidth="1.5" 
                  stroke="currentColor" 
                  className="w-5 h-5 text-orange-500 flex-shrink-0 transition-transform duration-300"
                  style={{ transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)' }}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-4 pt-2">
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default FAQSection;